import * as types from './constants'

export const defaultState = {
  jwt: null,
  loading: false,
  errors: {}
}

const sending = () => ({
  loading: true
})

const failed = (errors) => ({
  loading: false,
  jwt: null,
  errors
})

const successful = ({jwt, token}) => ({
  loading: false,
  errors: {},
  jwt: (jwt || token)
})

export default (state = defaultState, action) => {
  switch (action.type) {
  case types.AUTHORISATION_SENDING:
    return Object.assign(
      {},
      state,
      sending()
    )

  case types.AUTHORISATION_FAILED:
    return Object.assign(
      {},
      state,
      failed(action.errors)
    )

  case types.AUTHORISATION_SUCCESSFUL:
    return Object.assign(
      {},
      state,
      successful(action.data)
    )

  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/authorisation/reducer.js